/* eslint-disable */
const findWindow = typeof window === 'undefined' ? {} : window

const ensureStructure = window => {
  window.digitalData = window.digitalData || {}
  window.digitalData.page = window.digitalData.page || {}
  window.digitalData.page.attributes = window.digitalData.page.attributes || {}
  window.digitalData.page.attributes.recommendations = window.digitalData.page.attributes.recommendations || []
  window.digitalData.event = window.digitalData.event || []
  window.digitalData.track = window.digitalData.track || (() => {})
}

const randomString = (size = 20) => {
  let result = ''
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let length = size
  while (length > 0) {
    length -= 1
    result += chars[Math.round(Math.random() * (chars.length - 1))]
  }
  return result
}

const buildEvent = (eventName, eventAction, eventRef, recommendations) => {
  const event = {
    eventInfo: {
      eventName,
      eventAction,
      eventRef: eventRef || randomString(5)
    },
    attributes: {
      recommendations
    }
  }
  return event
}

const onRecommenderLoaded = recommenderOptions => {
  const { displayedList, fullList, title, placement, mvts, innerPlacement, ref, window } = recommenderOptions
  ensureStructure(window)
  const recommendations = {
    displayedList,
    fullList,
    title,
    placement,
    mvts,
    innerPlacement
  }
  const event = buildEvent('pdp_recommendationsLoaded', 'Recommendations Loaded', ref, recommendations)
  window.digitalData.page.attributes.recommendations.push(recommendations)
  window.digitalData.event.push(event)
  window.digitalData.track(event.eventInfo.eventName, {
    eventRef: event.eventInfo.eventRef
  })
  return window.digitalData.page.attributes.recommendations.length - 1
}

const onRecommenderInView = recommenderOptions => {
  const { displayedList, fullList, title, placement, mvts, innerPlacement, ref, window } = recommenderOptions
  ensureStructure(window)
  const recommendations = {
    displayedList,
    fullList,
    title,
    placement,
    mvts,
    innerPlacement
  }
  const event = buildEvent('pdp_recommendationsViewed', 'Recommendations Viewed', ref, recommendations)
  window.digitalData.event.push(event)
  window.digitalData.track(event.eventInfo.eventName, {
    eventRef: event.eventInfo.eventRef
  })
}

const onRecommenderChange = (recommenderOptions, recommendationIndex) => {
  const { displayedList, fullList, title, placement, mvts, innerPlacement, ref, window } = recommenderOptions
  ensureStructure(window)
  const recommendations = {
    displayedList,
    fullList,
    title,
    placement,
    mvts,
    innerPlacement
  }
  const event = buildEvent('pdp_recommendationsNewPageViewed', 'Recommendations New Page Viewed', ref, recommendations)
  window.digitalData.page.attributes.recommendations[recommendationIndex] = recommendations
  window.digitalData.event.push(event)
  window.digitalData.track(event.eventInfo.eventName, {
    eventRef: event.eventInfo.eventRef
  })
}

export { onRecommenderLoaded, onRecommenderInView, onRecommenderChange, buildEvent, ensureStructure }
